import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Header from './header';
import Footer from './footer';
import { jsonp } from '@ifeng/ui_base';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

const navData = {
    nav: [
        { title: '凤凰新媒体介绍', url: '//www.ifeng.com/corp/about/intro/' },
        { title: '投资者关系 Investor Relations', url: '//ir.ifeng.com/' },
        { title: '广告服务', url: '//biz.ifeng.com/' },
        { title: '诚征英才', url: '//career.ifeng.com/' },
        { title: '保护隐私权', url: '//www.ifeng.com/corp/privacy/' },
        { title: '免责条款', url: '//www.ifeng.com/corp/exemption/' },
        { title: '意见反馈', url: '//www.ifeng.com/corp/feedback/' },
        { title: '凤凰卫视介绍', url: '//phtv.ifeng.com/intro/' },
    ],
    content: {
        text0: '凤凰新媒体',
        text1: '版权所有',
        text2: 'Copyright © 2019 Phoenix New Media Limited All Rights Reserved.',
    },
};

const ths = [
    { en: 'Fri', cn: '23' },
    { en: 'Sat', cn: '24' },
    { en: 'Sun', cn: '25' },
    { en: 'Mon', cn: '26' },
    { en: 'Tue', cn: '27' },
    { en: 'Wed', cn: '28' },
    { en: 'Thu', cn: '29' },
    { en: 'Fri', cn: '30' },
    { en: 'Sat', cn: '31' },
    { en: 'Sun', cn: '1' },
    { en: 'Mon', cn: '2' },
    { en: 'Tue', cn: '3' },
    { en: 'Wed', cn: '4' },
    { en: 'Thu', cn: '5' },
    { en: 'Fri', cn: '6' },
    { en: 'Sat', cn: '7' },
    { en: 'Sun', cn: '8' },
];

const itemsMap = {
    射击: 'https://x0.ifengimg.com/ucms/2021_30/EB00C171DC60733A3662673116A44AA716CDB4CA_size1_w81_h71.png',
    摔跤: 'https://x0.ifengimg.com/ucms/2021_30/E64C47BA29F80AB6253CEE679A9E656861C9122E_size1_w81_h71.png',
    高尔夫: 'https://x0.ifengimg.com/ucms/2021_30/25D9BF6EC5E03A660BA8071FD47F4CB4A907DBFB_size1_w81_h71.png',
    田径: 'https://x0.ifengimg.com/ucms/2021_30/A69DD605E4B250B30F7B1F6FB57CCD3BD4D52730_size1_w81_h71.png',
    篮球: 'https://x0.ifengimg.com/ucms/2021_30/91FA4E731ACCE60F8683925169DE075F49489807_size1_w81_h71.png',
    滑板: 'https://x0.ifengimg.com/ucms/2021_30/F44E327359989C10BC428EA8733BE7C252BE188B_size1_w81_h71.png',
    击剑: 'https://x0.ifengimg.com/ucms/2021_30/4A1E70B0662C0640C513DE23BE217C462AE03CAF_size1_w81_h71.png',
    柔道: 'https://x0.ifengimg.com/ucms/2021_30/2E8F21134FC8E66282551B3DFE72375D46CD0ED0_size1_w81_h71.png',
    手球: 'https://x0.ifengimg.com/ucms/2021_30/4250AC794F2DE0E96F7AF9349505858F336C763C_size1_w81_h71.png',
    体操: 'https://x0.ifengimg.com/ucms/2021_30/CE5D2A8504DB20A965FD9C402B71FF649E3893BB_size1_w81_h71.png',
    游泳: 'https://x0.ifengimg.com/ucms/2021_30/8948EBE56BE9CC7DC0064A4FD074E9E882F8DE83_size1_w81_h71.png',
    足球: 'https://x0.ifengimg.com/ucms/2021_30/9459FB9758A25829C68846B3E2449D7CDC953BB7_size1_w81_h71.png',
    冲浪: 'https://x0.ifengimg.com/ucms/2021_30/03138BB5C233193010225C3261317487CB99F86A_size1_w81_h71.png',
    射箭: 'https://x0.ifengimg.com/ucms/2021_30/88425A30140E32EFAB65A17CE0AD24AA6B42912F_size1_w81_h71.png',
    曲棍球: 'https://x0.ifengimg.com/ucms/2021_30/41A8EAFCB1F385B698CA7D00655DE93F82DD6ED9_size1_w81_h71.png',
    小轮车: 'https://x0.ifengimg.com/ucms/2021_30/D3C8A6F5B5C9CE21EC2D30846CAE28C5D3E4695E_size1_w81_h71.png',
    跳水: 'https://x0.ifengimg.com/ucms/2021_30/A357DDBE4E542AAF4896D30B176E0AB8B0A31964_size1_w81_h71.png',
    攀岩: 'https://x0.ifengimg.com/ucms/2021_30/CF2C326378AB8CC1965E8787657C9405B055CDBC_size1_w81_h71.png',
    帆船: 'https://x0.ifengimg.com/ucms/2021_30/DF5C3C4651F8469A7E629020E96869B4669199F7_size1_w81_h71.png',
    羽毛球: 'https://x0.ifengimg.com/ucms/2021_30/B0D576D73CC3E50E59423D5D2D1CE58AF9610414_size1_w81_h71.png',
    空手道: 'https://x0.ifengimg.com/ucms/2021_30/B577F4C6C322D45BE9D80EFE958A31A010A5D074_size1_w81_h71.png',
    赛艇: 'https://x0.ifengimg.com/ucms/2021_30/B97CFED24551C5163D72DA782A668DF60D2F2269_size1_w81_h71.png',
    橄榄球: 'https://x0.ifengimg.com/ucms/2021_30/99A11AD4755079BC8CFF23E30EA340F15A05C9FF_size1_w81_h71.png',
    自行车: 'https://x0.ifengimg.com/ucms/2021_30/863A6E11CAFCF72B91CD3D3A47E41124A528A8C7_size1_w81_h71.png',
    乒乓球: 'https://x0.ifengimg.com/ucms/2021_30/F1D7261D2BE5C6B4126B865243A54261231FFDDC_size1_w81_h71.png',
    排球: 'https://x0.ifengimg.com/ucms/2021_30/EDEA93865AC36BABB4144722F030C5D8A3E1BCE9_size1_w81_h71.png',
    棒球: 'https://x0.ifengimg.com/ucms/2021_30/6CC646A610FB8F39A32007C1999E3D5F42A45BCC_size1_w81_h71.png',
    皮划艇: 'https://x0.ifengimg.com/ucms/2021_30/D2094AE0FD54A33746DB9D952221CD6EFA9D00D9_size1_w81_h71.png',
    铁人三项: 'https://x0.ifengimg.com/ucms/2021_30/8E5C8A9E9568AD1CADBADA7E60508CF8E404258D_size1_w81_h71.png',
    水球: 'https://x0.ifengimg.com/ucms/2021_30/903F70A7AEF02643972E0B72F624AD893325EA9A_size1_w81_h71.png',
    举重: 'https://x0.ifengimg.com/ucms/2021_30/553C9B0AE48CE2F25EF8F82224898E3061FAF085_size1_w81_h71.png',
    网球: 'https://x0.ifengimg.com/ucms/2021_30/22FDB7A6D2891DF90F2680A6BC1C28C2ACD18E2E_size1_w81_h71.png',
    跆拳道: 'https://x0.ifengimg.com/ucms/2021_30/438C5D917701C8E774FAB407EEBD80AE34DB62D2_size1_w81_h71.png',
    马术: 'https://x0.ifengimg.com/ucms/2021_30/082A0D718F31C89A1B0113390EC07E508F0837E2_size1_w81_h71.png',
    现代五项: 'https://x0.ifengimg.com/ucms/2021_30/88DE14A8724E55283FBC68AF7FE25F72FE3C99DC_size1_w81_h71.png',
    蹦床: 'https://x0.ifengimg.com/ucms/2021_30/E2402D30C91C206C17228F6653BC3250907639DC_size1_w81_h71.png',
    拳击: 'https://x0.ifengimg.com/ucms/2021_30/6803A54FF180E31D9A4F26B907B7A4A2B6145D5B_size1_w81_h71.png',
};

class Layout extends React.PureComponent {
    state = {
        scheduleList: [],
        todayIndex: -1,
    };

    componentDidMount() {
        jsonp('https://shankapi.ifeng.com/feedflow/japan/pc/schedule/cb', {
            jsonp: 'callback',
            jsonpCallback: 'cb',
            cache: false,
        }).then(res => {
            if (res.code === 0) {
                this.setState({
                    scheduleList: res.data,
                });
            }
        });

        const date = new Date();
        const day = date.getDate();

        const index = ths.findIndex(t => t.cn === day.toString());

        this.setState({
            todayIndex: index,
        });
    }

    getPattContent = text => {
        if (/##(gold|silver|copper)\s(.+)##/g.test(text)) {
            const gold = /##gold\s(.+?)##/.exec(text);
            const silver = /##silver\s(.+?)##/.exec(text);
            const copper = /##copper\s(.+?)##/.exec(text);

            const goldCountry = gold ? gold[0].replace('##gold ', '').replace('##', '') : undefined;
            const silverCountry = silver ? silver[0].replace('##silver ', '').replace('##', '') : undefined;
            const copperCountry = copper ? copper[0].replace('##copper ', '').replace('##', '') : undefined;

            return (
                <span className={styles.modalSpan}>
                    {goldCountry && (
                        <>
                            {goldCountry}
                            <img
                                src="https://x0.ifengimg.com/ucms/2021_29/037003FDF1DEB466740269661AFF983348FE8A43_size2_w22_h30.png"
                                alt={'金牌'}
                            />
                        </>
                    )}
                    {silverCountry && (
                        <>
                            {silverCountry}
                            <img
                                src="https://x0.ifengimg.com/ucms/2021_29/4FC213904E7D776CBCAEB37716E6AFA9F2C6BEC6_size2_w22_h30.png"
                                alt={'银牌'}
                            />
                        </>
                    )}
                    {copperCountry && (
                        <>
                            {copperCountry}
                            <img
                                src="https://x0.ifengimg.com/ucms/2021_29/419591027C669852C123462AD9D390D636EF53F4_size2_w22_h30.png"
                                alt={'铜牌'}
                            />
                        </>
                    )}
                </span>
            );
        } else {
            return text;
        }
    };

    render() {
        const { scheduleList, todayIndex } = this.state;

        return (
            <div>
                <div style={{ backgroundColor: '#ffffff' }}>
                    <div className={styles.layout}>
                        <Header />
                    </div>
                </div>
                <div className={styles.banner}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2021_30/B9961E34C87D1C1C6E4EDBDA5D4898EA1CE5649E_size327_w2560_h814.png"
                        alt="赛程"
                    />
                </div>
                <div className={styles.layout}>
                    <div className={styles.main}>
                        <div className={styles.table_wp}>
                            <table className={styles.table}>
                                <tbody>
                                    <tr>
                                        <th colSpan={2} className={styles.type}>
                                            <div className={styles.en}>Date</div>
                                            <div className={styles.cn}>日期</div>
                                        </th>
                                        {ths.map((th, index) => (
                                            <th key={index} className={index === todayIndex ? styles.today : ''}>
                                                <div className={styles.en}>{th.en}</div>
                                                <div className={styles.cn}>{th.cn}</div>
                                            </th>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={19} className={styles.tips}>
                                            <div>
                                                <span>
                                                    <div
                                                        className={styles.block}
                                                        style={{ backgroundColor: '#72BFFF' }}
                                                    />代表比赛日
                                                </span>
                                                <span>
                                                    <div
                                                        className={styles.block}
                                                        style={{ backgroundColor: '#269BFB' }}
                                                    />代表决赛日
                                                </span>
                                                <span>数字：代表当日产生的金牌数量</span>
                                                <span>比赛日以北京时间为准</span>
                                            </div>
                                        </td>
                                    </tr>
                                    {scheduleList.map((schedule, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className={styles.icon}>
                                                    <img src={itemsMap[schedule.name]} alt={schedule.name} />
                                                </td>
                                                <td>{schedule.name}</td>
                                                {schedule.data.map((s, idx) => {
                                                    return s.list.length > 0 ? (
                                                        <td
                                                            className={s.gold ? styles.important : styles.normal}
                                                            key={`goldTd${idx}`}>
                                                            {s.list.filter(s => s.pcShow).length > 0 ? (
                                                                <Tooltip
                                                                    placement="bottom"
                                                                    overlayClassName={styles.tooltip}
                                                                    trigger={['hover']}
                                                                    overlay={
                                                                        <table className={styles.tooltipTable}>
                                                                            <tbody>
                                                                                {s.list
                                                                                    .filter(s => s.pcShow)
                                                                                    .map((l, i) => {
                                                                                        return (
                                                                                            <tr key={i}>
                                                                                                <td>{l.time}</td>
                                                                                                <td>{l.name}</td>
                                                                                                <td>
                                                                                                    {this.getPattContent(
                                                                                                        l.desc,
                                                                                                    )}
                                                                                                </td>
                                                                                                {l.url && (
                                                                                                    <td>
                                                                                                        <a
                                                                                                            href={l.url}
                                                                                                            target="_blank">
                                                                                                            战报
                                                                                                        </a>
                                                                                                    </td>
                                                                                                )}
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                            </tbody>
                                                                        </table>
                                                                    }>
                                                                    <div
                                                                        className={`${styles.td_contain} ${s.isChina &&
                                                                            styles.china}`}>
                                                                        <span className={styles.goldNum}>
                                                                            {s.gold && s.goldNum}
                                                                        </span>
                                                                    </div>
                                                                </Tooltip>
                                                            ) : (
                                                                <div
                                                                    className={`${styles.td_contain} ${s.isChina &&
                                                                        styles.china}`}
                                                                    key={`td${idx}`}>
                                                                    <span className={styles.goldNum}>
                                                                        {s.gold && s.goldNum}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </td>
                                                    ) : (
                                                        <td key={`div${index}-${idx}`} />
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className={styles.footer}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2021_30/56F265240185C808090444A7505BA44598E38D99_size24_w2560_h139.png"
                        alt="页尾"
                        className={styles.normal}
                    />
                    <img
                        src="https://x0.ifengimg.com/ucms/2021_30/A85E31C096A1912D554ACF00784E8C2F2A1D165E_size8_w742_h30.png"
                        className={styles.text}
                    />
                </div>
                <div className={styles.layout}>
                    <Footer content={navData} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Layout);
